import * as React from 'react';
import { useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { ArrayFieldItemContext } from './ArrayFieldItemContext';
/** The `ArrayFieldItemTemplate` component is the template used to render an items of an array.
 *
 * @param props - The `ArrayFieldTemplateItemType` props for the component
 */
export function ArrayFieldItemTemplate(props) {
    var children = props.children, disabled = props.disabled, hasToolbar = props.hasToolbar, hasCopy = props.hasCopy, hasMoveDown = props.hasMoveDown, hasMoveUp = props.hasMoveUp, hasRemove = props.hasRemove, index = props.index, onCopyIndexClick = props.onCopyIndexClick, onDropIndexClick = props.onDropIndexClick, onReorderClick = props.onReorderClick, readonly = props.readonly, uiSchema = props.uiSchema, registry = props.registry;
    var _a = registry.templates.ButtonTemplates, CopyButton = _a.CopyButton, MoveDownButton = _a.MoveDownButton, MoveUpButton = _a.MoveUpButton, RemoveButton = _a.RemoveButton;
    var btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        minWidth: 0,
    };
    var contextValue = useMemo(function () { return ({ index: index }); }, [index]);
    return (React.createElement(Grid, { container: true, alignItems: "center" },
        React.createElement(Grid, { item: true, xs: true, style: { overflow: 'auto' } },
            React.createElement(Box, { mb: 2 },
                React.createElement(Box, { p: 2 },
                    React.createElement(ArrayFieldItemContext.Provider, { value: contextValue }, children)))),
        hasToolbar && (React.createElement(Grid, { item: true },
            (hasMoveUp || hasMoveDown) && (React.createElement(MoveUpButton, { style: btnStyle, disabled: disabled || readonly || !hasMoveUp, onClick: onReorderClick(index, index - 1), uiSchema: uiSchema, registry: registry })),
            (hasMoveUp || hasMoveDown) && (React.createElement(MoveDownButton, { style: btnStyle, disabled: disabled || readonly || !hasMoveDown, onClick: onReorderClick(index, index + 1), uiSchema: uiSchema, registry: registry })),
            hasCopy && (React.createElement(CopyButton, { style: btnStyle, disabled: disabled || readonly, onClick: onCopyIndexClick(index), uiSchema: uiSchema, registry: registry })),
            hasRemove && (React.createElement(RemoveButton, { style: btnStyle, disabled: disabled || readonly, onClick: onDropIndexClick(index), uiSchema: uiSchema, registry: registry }))))));
}
